import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=f3ae4ba8&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=f3ae4ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ae4ba8",
  null
  
)

export default component.exports